export const COLOR_PALETTES = {
  teal: {
    tone: "teal",
    paint: "var(--teal-9)",
    surface: "bg-accent-teal-subtle",
    foreground: "text-accent-teal",
    border: "border-accent-teal-line",
    hover: "hover:bg-accent-teal-subtle-hovered",
    emphasis: "bg-accent-teal-subtle-hovered",
    solid: "bg-accent-teal-bold",
    solidForeground: "text-white",
  },
  green: {
    tone: "green",
    paint: "var(--green-9)",
    surface: "bg-accent-green-subtle",
    foreground: "text-accent-green",
    border: "border-accent-green-line",
    hover: "hover:bg-accent-green-subtle-hovered",
    emphasis: "bg-accent-green-subtle-hovered",
    solid: "bg-accent-green-bold",
    solidForeground: "text-white",
  },
  blue: {
    tone: "blue",
    paint: "var(--blue-9)",
    surface: "bg-accent-blue-subtle",
    foreground: "text-accent-blue",
    border: "border-accent-blue-line",
    hover: "hover:bg-accent-blue-subtle-hovered",
    emphasis: "bg-accent-blue-subtle-hovered",
    solid: "bg-accent-blue-bold",
    solidForeground: "text-white",
  },
  purple: {
    tone: "purple",
    paint: "var(--purple-9)",
    surface: "bg-accent-purple-subtle",
    foreground: "text-accent-purple",
    border: "border-accent-purple-line",
    hover: "hover:bg-accent-purple-subtle-hovered",
    emphasis: "bg-accent-purple-subtle-hovered",
    solid: "bg-accent-purple-bold",
    solidForeground: "text-white",
  },
  plum: {
    tone: "plum",
    paint: "var(--plum-9)",
    surface: "bg-accent-plum-subtle",
    foreground: "text-accent-plum",
    border: "border-accent-plum-line",
    hover: "hover:bg-accent-plum-subtle-hovered",
    emphasis: "bg-accent-plum-subtle-hovered",
    solid: "bg-accent-plum-bold",
    solidForeground: "text-white",
  },
  amber: {
    tone: "amber",
    paint: "var(--amber-9)",
    surface: "bg-accent-amber-subtle",
    foreground: "text-accent-amber",
    border: "border-accent-amber-line",
    hover: "hover:bg-accent-amber-subtle-hovered",
    emphasis: "bg-accent-amber-subtle-hovered",
    solid: "bg-accent-amber-bold",
    solidForeground: "text-on-warning",
  },
  red: {
    tone: "red",
    paint: "var(--red-9)",
    surface: "bg-accent-red-subtle",
    foreground: "text-accent-red",
    border: "border-accent-red-line",
    hover: "hover:bg-accent-red-subtle-hovered",
    emphasis: "bg-accent-red-subtle-hovered",
    solid: "bg-accent-red-bold",
    solidForeground: "text-white",
  },
  orange: {
    tone: "orange",
    paint: "var(--orange-9)",
    surface: "bg-accent-orange-subtle",
    foreground: "text-accent-orange",
    border: "border-accent-orange-line",
    hover: "hover:bg-accent-orange-subtle-hovered",
    emphasis: "bg-accent-orange-subtle-hovered",
    solid: "bg-accent-orange-bold",
    solidForeground: "text-white",
  },
  cyan: {
    tone: "cyan",
    paint: "var(--cyan-9)",
    surface: "bg-accent-cyan-subtle",
    foreground: "text-accent-cyan",
    border: "border-accent-cyan-line",
    hover: "hover:bg-accent-cyan-subtle-hovered",
    emphasis: "bg-accent-cyan-subtle-hovered",
    solid: "bg-accent-cyan-bold",
    solidForeground: "text-white",
  },
  sand: {
    tone: "sand",
    paint: "var(--sand-9)",
    surface: "bg-accent-sand-subtle",
    foreground: "text-accent-sand",
    border: "border-accent-sand-line",
    hover: "hover:bg-accent-sand-subtle-hovered",
    emphasis: "bg-accent-sand-subtle-hovered",
    solid: "bg-accent-sand-bold",
    solidForeground: "text-ink",
  },
} as const;

export type PaletteName = keyof typeof COLOR_PALETTES;
export type ColorPalette = (typeof COLOR_PALETTES)[PaletteName];
